export const WorkflowIntegrationType = {
  NONE: 'none',
  PROCUREMENT: 'procurement',
  WSS_ONLY: 'wss_only',
} as const;

export type WorkflowIntegrationTypeValue =
  (typeof WorkflowIntegrationType)[keyof typeof WorkflowIntegrationType];
